/* =======================================================================
   商品詳細 : 関連商品カルーセル
   - 既存の商品カード（.s-grid .item）をそのままスライドとして流用
   - 件数が slidesPerView 以下のときは watchOverflow により
     矢印・ドットが自動で無効化される（スライドしない）
   ======================================================================= */
(function () {
  'use strict';

  if (typeof Swiper === 'undefined') { return; }

  var el = document.querySelector('.s-related_carousel');
  if (!el) { return; }

  new Swiper(el, {
    // Swiper 5 の breakpoints は min-width（モバイルファースト）判定。
    // ここの値はSPの初期値として扱われ、breakpoints が上の幅を上書きする。
    slidesPerView: 2,
    spaceBetween: 14,
    // 小数幅の端末で次スライドの端が覗くのを防ぐ
    roundLengths: true,
    watchOverflow: true,
    navigation: {
      prevEl: '.s-related_arrow--prev',
      nextEl: '.s-related_arrow--next'
    },
    pagination: {
      el: '.s-related_dots',
      clickable: true
    },
    breakpoints: {
      750:  { slidesPerView: 2, spaceBetween: 20 },   // タブレット
      1024: { slidesPerView: 3, spaceBetween: 28 }    // PC
    }
  });
})();
